import { Typography } from "@mui/material";
import type { FC } from "react";
import type { Currency } from "../../data/BaseEntity";
import type { Price } from "../../misc/price";

interface Props {
  readonly price: Price;
  readonly currency?: Currency;
}

const ProductPrice: FC<Props> = ({ price, currency }) => {
  return <Typography data-testid="product-price">{price.toDisplayValue(currency)}</Typography>;
};

export default ProductPrice;
